<template>
  <div class="cpu-other">
    <div class="cpu" id="cpu" ref="cpu"></div>
    <div class="cpu-box">
      <div class="date">
        <div>
          <span>min</span>
          <span>max</span>
          <span>mvg</span>
          <span>curant*</span>
        </div>
      </div>
      <div class="date-box">
        <div class="left">
          <span></span>
          <span>总使用率</span>
        </div>
        <div class="right">
          <span>{{ this.needData.Min }}%</span>
          <span>{{ this.needData.Max }}%</span>
          <span>{{ this.needData.Mvg }}%</span>
          <span>{{ this.needData.Curant }}%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["needData"],
  data() {
    return {};
  },
  mounted() {
    // setTimeout(()=>{
    //    this.cpu(this.needData);
    // },200)
      this.cpu(this.needData);
  },
  // watch: {
  //   'needData'() {
  //     this.cpu(this.needData);
  //   },
  // },
  methods: {
    cpu(param) {
      let myEchart = this.$echarts.init(document.getElementById("cpu"));
      var date = [];
      param.DateTime.forEach((item) => {
        date.push(item.substring(item.length - 5));
      });

      // var base = +new Date(2022, 0, 0);
      // var oneDay = 24 * 3600 * 1000;
      // var date = [];

      // var data = [Math.random() * 200];
      // var data2 = [Math.random() * 500];
      // var data3 = [Math.random() * 700];
      // var data4 = [Math.random() * 900];

      // for (var i = 1; i < 367; i++) {
      //   var now = new Date((base += oneDay));
      //   date.push(
      //     [now.getFullYear(), now.getMonth() + 1, now.getDate()].join("/")
      //   );
      //   data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
      //   data2.push(Math.round((Math.random() - 0.5) * 20 + data2[i - 1]));
      //   data3.push(Math.round((Math.random() - 0.5) * 20 + data3[i - 1]));
      //   data4.push(Math.round((Math.random() - 0.5) * 20 + data4[i - 1]));
      // }

      let option = {
        grid: {
          top: "12%",
          left: "8%",
          bottom: "25%",
          right: "5%",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisTick: {
            show: false,
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(%)",
          nameGap: 10,
          nameTextStyle: {
            padding: [0, 40, 0, 0],
          },
          boundaryGap: [0, "100%"],
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "2020预算",
            type: "line",
            smooth: true,
            stack: "",
            symbol: "none",
            sampling: "average",
            lineStyle: {
              color: "#c7f4fc",
              width: 1,
              shadowBlur: 6,
              shadowColor: "rgba(199,244,252,1)",
              shadowOffsetY: 3.5,
            },

            data: param.Data1,
          },
          // {
          //   name: "2019预算",
          //   type: "line",
          //   smooth: true,
          //   symbol: "none",
          //   sampling: "average",
          //   lineStyle: {
          //     color: "#02d3f9",
          //     width: 1,
          //     shadowBlur: 6,
          //     shadowColor: "rgba(2,211,249,1)",
          //     shadowOffsetY: 3.5,
          //   },
          //   data: data2,
          // },
          // {
          //   name: "本行指标",
          //   type: "line",
          //   smooth: true,
          //   symbol: "none",
          //   sampling: "average",
          //   lineStyle: {
          //     color: "#e89d0a",
          //     width: 1,
          //     shadowBlur: 6,
          //     shadowColor: "rgba(232,157,10,1)",
          //     shadowOffsetY: 3.5,
          //   },
          //   data: data3,
          // },
          // {
          //   name: "2019同业",
          //   type: "line",
          //   smooth: true,
          //   symbol: "none",
          //   sampling: "average",
          //   lineStyle: {
          //     color: "#e72c2d",
          //     width: 1,
          //     shadowBlur: 6,
          //     shadowColor: "#e72c2d",
          //     shadowOffsetY: 3.5,
          //   },
          //   data: data4,
          // },
        ],
      };
      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.cpu-other {
  width: 100%;
  height: 100%;
  position: relative;
}
.cpu {
  width: 100%;
  height: 100%;
}

.cpu-box {
  width: 95%;
  height: 4.6vh;
  position: absolute;
  bottom: 0;
  left: 3%;
}
.cpu-box .date {
  width: 100%;
  height: 1.6vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #00e4ff;
  font-size: 0.6vw;
}

.cpu-box .date div {
  width: 44%;
  height: 100%;
  align-items: center;
  justify-content: space-around;
}
.cpu-box .date div span {
  height: 100%;
  margin-right: 1.14vw;
  transform: scale(0.7);
  line-height: 1vh;
}

.cpu-box .date-box {
  width: 100%;
  height: 2.3vh;
  background: url("../../assets/img/74.png");
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.6vw;
}

.cpu-box .date-box .left {
  width: 16%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.6vw;
  justify-content: space-between;
  margin-left: 1vw;
}

.cpu-box .date-box .left span:nth-child(1) {
  width: 1.45vw;
  height: 0.7vh;
  background: red;
}
.cpu-box .date-box .left span:nth-child(2) {
  color: #aebfc4;
}

.cpu-box .date-box .right {
  width: 32%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #aebfc4;
  margin-right: 2.5vw;
}
</style>


